const LocationFooter = () => {
  return (
    <>
      <h5>WHY THIS MATTERS</h5>
      <p>MediFind will identify trials for your condition within the specified range.</p>
    </>
  );
};

export default LocationFooter;
